export default "__VITE_ASSET__lVOqPDgT__"